import CloseFilled16 from '@carbon/icons-react/es/close--filled/16';
import { ButtonProps } from 'antd/es/button';
import React, { FC } from 'react';
import styled from 'styled-components';
import { Button as ButtonAtom } from './button';

const Button = styled(ButtonAtom)`
  height: 16px;
  padding: 0;
  position: absolute;
  top: 2px;
  right: 2px;
  min-width: 16px;
  width: 16px;
  z-index: 0;
  &:hover {
    color: var(--error-color);
    border-color: var(--error-color);
  }
`;

export const CloseButton: FC<ButtonProps> = (props) => (
  <Button
    icon={<CloseFilled16 />}
    shape="round"
    size="small"
    type="default"
    {...props}
  />
);
